import { isPlatformBrowser, NgClass, NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, Inject, PLATFORM_ID, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { AccordionStateService } from '../../services/accordion-state.service';
import { Router, RouterLink } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { ApiService } from '../../services/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-product-card',
  imports: [NgIf, NgClass, TooltipModule, FormsModule, RouterLink],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-100'
  },
})
export class ProductCardComponent implements OnInit, OnDestroy {
  showQuantityState: {
    [key: string]: {
      visible: boolean;
      locked?: boolean;
    };
  } = {};
  warningTimeout: any;
  autoHideTimer: any;
  hideTooltip: boolean = false;
  tooltipTimeout: any;
  lockedWishlistTooltip: string = '';
  lockedProductTooltip: string = '';

  @Input() currentSearch: any;
  @Input() item: any;
  @Input() isLogin: boolean = false;
  @Input() onClickCompare: any
  @Input() enableCompare = false;
  @Input() compareList: any;
  @Input() clickedCompareIndex: any
  @Input() i: any;
  @Input() recentPage: boolean = false;
  @Input() wishlist: boolean = false;
  @Input() gridView: boolean = false;
  /** Picker mode (the Request a Quote drawer): the card neither links to the product page
   *  nor adds to cart; the whole card and its SELECT button emit `productSelect` instead. */
  @Input() selectMode: boolean = false;
  @Output() productSelect = new EventEmitter<any>();
  hoveredIndex: number = -1;

  cartList: any = [];
  currentPath: string = '';
  cartSubscription: Subscription = new Subscription();
  popupSyncSubscription: Subscription = new Subscription();
  debounceTimer: any;
  showEnabled: boolean = false;
  showCartWarning = false;
  showLogin = false;
  isProcessing = false;
  wishlistLogin = false;
  quotesId: any;
  popupMode: 'list' | 'configure' = 'list';

  @ViewChild('loginPopup') loginPopup!: ElementRef;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.showLogin && this.loginPopup && !this.loginPopup.nativeElement.contains(event.target)) {
      this.showLogin = false;
    }
  }

  constructor(
    private route: Router,
    public accordionState: AccordionStateService,
    private util: UtilService,
    private api: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (this.item) {
      this.item.enabledSpecs = this.item?.attributesDTOs?.filter(
        (attr: any) => attr.isFiltered
      );

      if (!this.item.enabledSpecs?.length) {
        this.item.enabledSpecs = this.item?.attributesDTOs || [];
        this.item?.enabledSpecs?.forEach(
          (attr: any) => (attr.isFiltered = true)
        );
      }
    }
    this.cartSubscription = this.util.cart$.subscribe((cart: any) => {
      this.cartList = cart;
    });

    if (this.item.istwice) {
      this.popupSyncSubscription = this.util.popupCartUpdate$.subscribe((cart: any) => {
        // this.cartList = cart;
        const cartItems = cart?.items || cart || [];
        const firstCartItem = cartItems[0];

        if (this.item?.urlSlug && firstCartItem && this.item.urlSlug === firstCartItem?.product?.urlSlug) {

          const productSlug = (this.item.product?.urlSlug || this.item.urlSlug || '')
            .trim()
            .toLowerCase();

          const matchingItems = cartItems.filter((cartItem: any) => {
            const cartItemSlug = (cartItem.product?.urlSlug || cartItem.urlSlug || '')
              .trim()
              .toLowerCase();

            return cartItemSlug === productSlug && productSlug !== '';
          });

          console.log(matchingItems, 'items i am matching with');

          if (matchingItems.length > 1) {
            this.item.istwice = true;
            this.item.cartId = matchingItems[0].cartId;
            this.item.cartQty = matchingItems[0].qty;
            this.item.qty = matchingItems[0].qty;
          } else if (matchingItems.length === 1) {
            this.item.istwice = false;
            this.item.cartId = matchingItems[0].cartId;
            this.item.cartQty = matchingItems[0].qty;
            this.item.qty = matchingItems[0].qty;
          } else {
            this.item.istwice = false;
            this.item.cartId = '';
            this.item.cartQty = 0;
            this.item.qty = 0;
          }
        } else {
          this.item.istwice = false;
          this.item.cartId = '';
          this.item.cartQty = 0;
          this.item.qty = 0;
        }
      });
    }
  }

  ngOnDestroy() {
    this.cartSubscription.unsubscribe();
    this.popupSyncSubscription.unsubscribe();
  }

  aleradyInCartOnHover() {
    this.showCartWarning = true;
    if (this.warningTimeout) clearTimeout(this.warningTimeout);
    this.warningTimeout = setTimeout(() => {
      this.showCartWarning = false;
    }, 3000);
  }

  async handlePlus(cart: any, event: Event, val = false) {
    console.log(cart)
    if (
      (cart.productStatus == 4 ||
        cart.productStatus == 0 ||
        cart.productStatus == null) &&
      this.isLogin
    ) {
      cart.cartQty = 0;
      cart.qty = 0;
      return;
    }
    else if (cart.productStatus == 3 && cart.inventoryQty == 0 && this.isLogin) {
      cart.cartQty = 0;
      cart.qty = 0;
      return;
    }
    else {
      event.stopPropagation();

      if (val === true) {
        this.handleMultiple(cart, event);
      } else {
        try {

          if (cart.isProcessing) return;
          let inCart = this.cartList?.items?.find((item: any) => {
            const itemSlug = (item.product?.urlSlug || item.urlSlug || '')
              .trim()
              .toLowerCase();
            const cartSlug = (cart.product?.urlSlug || cart.urlSlug || '')
              .trim()
              .toLowerCase();
            return itemSlug === cartSlug;
          });
          if (!inCart) {
            cart.isProcessing = true;
            let res = await this.performAddToCart(cart, 1);
            let item = res.items.filter(
              (item: any) => item.product.urlSlug == cart.urlSlug
            );
            cart.cartQty = item[0].qty;
            cart.qty = item[0].qty;
            cart.isProcessing = false;
            this.cartList = res;
            this.util.CartUpdated(res);
          } else {
            const cartId = inCart.cartId;
            cart.cartQty = Number(cart.cartQty) + 1;
            cart.qty = Number(cart.qty) + 1;
            let cartData = await this.api.updateCart(cartId, cart.cartQty);
            this.hideMobileTooltip()
            this.util.showQuotesToast('Added to cart', 'success', undefined);
            this.util.CartUpdated(cartData);
            this.cartList = cartData;
          }
        } catch (err) {
          console.log(err);
          cart.isProcessing = false;
        }
      }
    }
  }

  async handleMinus(cart: any, event: Event) {
    event.stopPropagation();
    cart.cartQty = Number(cart.cartQty)
    cart.qty = Number(cart.qty)
    if (cart.cartQty >= 0 || cart.qty >= 0) {
      if (!cart || cart.cartQty < 0 || cart.qty < 0) return;
      if (cart.cartQty == 0 && cart.qty == 0) {
        return
      }
      if (cart.qty <= 0 || cart.cartQty <= 0) {
        return;
      }
      cart.cartQty -= 1;
      cart.qty -= 1;

      if (cart.qty == 0 || cart.cartQty == 0) {
        this.zeroQty(cart)
        return
      }
      const cartItem = this.cartList?.items?.find((item: any) => {
        const itemSlug = (item.product?.urlSlug || item.urlSlug || '')
          .trim()
          .toLowerCase();
        const cartSlug = (cart.product?.urlSlug || cart.urlSlug || '')
          .trim()
          .toLowerCase();
        return itemSlug === cartSlug;
      });
      if (cartItem) {
        const cartId = cartItem.cartId;
        let cartData = await this.api.updateCart(cartId, cart.cartQty);
        this.hideMobileTooltip()
        this.util.CartUpdated(cartData);
        this.cartList = cartData;
      }
    }
  }

  async zeroQty(cart: any) {
    const cartItem = this.cartList?.items?.find((item: any) => {
      const itemSlug = (item.product?.urlSlug || item.urlSlug || '')
        .trim()
        .toLowerCase();
      const cartSlug = (cart.product?.urlSlug || cart.urlSlug || '')
        .trim()
        .toLowerCase();
      return itemSlug === cartSlug;
    });
    let res = await this.api.updateCart(
      cartItem.cartId,
      cart.qty || cart.cartQty
    );
    await this.api.removeCart(cartItem.cartId);
    cart.cartQty = 0;
    cart.qty = 0;
    res.items = res.items.filter((item: any) =>
      item.urlSlug
        ? item.urlSlug != cart.urlSlug
        : item.product.urlSlug != cart.urlSlug
    );
    this.util.CartUpdated(res);
    this.cartList = res;
  }

  @Output() removeFromWishlist = new EventEmitter<any>();
  async onClickWishlist(item: any, event: Event, userName: any) {
    this.resetTooltip();
    event.stopPropagation();
    event.preventDefault();
    if (userName === undefined) {
      this.storeProductInSessionStorage(item);
      this.route.navigateByUrl('/login');
    } else {
      if (item.isWishlisted == true || item.customerWishListId) {
        try {
          await this.api.removeWishList(item.urlSlug);
          this.hideMobileTooltip()
          this.util.showQuotesToast('Removed from wishlist', 'success', undefined);
          item.isWishlisted = false;
          this.removeFromWishlist.emit(item);
        } catch (error) {
          console.error(error);
        }
      } else {
        let data = {
          urlSlug: item.urlSlug,
        };
        try {
          let res = await this.api.addToWishlist(data);
          this.hideMobileTooltip();
          item.isWishlisted = true;
          if (isPlatformBrowser(this.platformId) && !sessionStorage.getItem('wishlistPopupShown')) {
            sessionStorage.setItem('wishlistPopupShown', 'true');
            this.util.showWishlistNotification(item);
          } else {
            this.util.showQuotesToast('Added to wishlist', 'success', undefined);
          }
        } catch (err: any) {
          if (this.util.isCustomerNotFoundError(err)) {
            this.util.showQuotesToast('Please login with a customer', 'error', 'Error');
          }
          console.error(err);
        }
      }
    }
  }

  private async performAddToCart(item: any, qty: number) {
    const cartBody = {
      qty,
      productSlug: item.urlSlug,
    };
    console.log(item, 'item i am from card');
    if (item?.productOptionsDTO?.length > 0) {
      this.util.triggerMultipleVarients(item);
      return; 0
    }

    try {
      const currentcart = await this.api.addToCart(cartBody);
      this.hideMobileTooltip()
      this.util.CartUpdated(currentcart);
      this.util.showCartNotification(item);
      return currentcart;
    } catch (err: any) {
      if (this.util.isCustomerNotFoundError(err)) {
        this.util.showQuotesToast('Please login with a customer', 'error', 'Error');
        item.qty = 0;
        item.cartQty = 0;
      }
      console.error('Add to cart failed:', err);
      throw err;
    }
  }

  async handleMultiple(item: any, event: Event) {
    event.stopPropagation();

    if (!item) return;
    if (item.cartQty == null) {
      return;
    }
    if (item.cartQty < 0) return;

    clearTimeout(this.debounceTimer);
    const inCart = this.cartList?.items?.find((cart: any) =>
      cart.product?.urlSlug
        ? cart.product.urlSlug === item.urlSlug
        : cart.urlSlug === item.urlSlug
    );

    if (inCart) {
      const cartId = inCart.cartId;
      this.debounceTimer = setTimeout(async () => {
        if (item.cartQty === 0) {
          this.zeroQty(item);
          return;
        }

        const cartData = await this.api.updateCart(cartId, item.cartQty);
        this.hideMobileTooltip()
        this.util.CartUpdated(cartData);
        this.cartList = cartData;
        this.util.showQuotesToast('Added to cart', 'success', undefined);
      }, 500);

    } else {
      this.debounceTimer = setTimeout(async () => {
        if (item.cartQty === 0) {
          this.zeroQty(item);
          return;
        }

        const res = await this.performAddToCart(item, item.cartQty);
        this.util.CartUpdated(res);
        this.cartList = res;
      }, 500);
    }
  }

  enableMobilePopup() {
    this.showEnabled = true;
  }
  handleCompareClick(item: any, index: number) {
    this.clickedCompareIndex = index;
    this.onClickCompare(item);
  }

  handleClick(event: Event) {
    event.stopPropagation();
  }

  // async onClickCompare(item: any) {
  //   this.onClickCompareFunc(item)
  // }

  getProductUrl(slug: string): string {
    const currentPath = this.route.url.split('?')[0];
    if (currentPath.startsWith('/category')) {
      const segments = currentPath.split('/').filter(s => s);
      const categoryIndex = segments.indexOf('category');
      const afterCategory = segments.length - (categoryIndex + 1);
      if (afterCategory === 4 || afterCategory === 5) {
        segments.pop();
      }
      return '/' + segments.join('/') + '/' + slug;
    }
    return '/product/' + slug;
  }

  onProductCardClick(event: MouseEvent, item: any, index: number) {
    if (this.selectMode) {
      event.preventDefault();
      this.productSelect.emit(item);
      return;
    }

    if (this.enableCompare) {
      event.preventDefault();
      this.handleCompareClick(item, index);
      return;
    }

    // Store in session storage for non-logged-in users
    if (!this.isLogin && this.item) {
      this.storeProductInSessionStorage(this.item);
    }
  }

  navigateToProduct(slug: string) {
    if (!this.isLogin && this.item) {
      this.storeProductInSessionStorage(this.item);
    }

    const currentPath = this.route.url.split('?')[0];

    if (currentPath.startsWith('/category')) {

      const segments = currentPath.split('/').filter(s => s);

      const categoryIndex = segments.indexOf('category');
      const afterCategory = segments.length - (categoryIndex + 1);

      if (afterCategory === 4 || afterCategory === 5) {
        segments.pop();
      }

      const newPath = '/' + segments.join('/') + '/' + slug;

      this.route.navigateByUrl(newPath);

    } else if (this.currentPath === '/') {
      this.route.navigateByUrl(`product/${slug}`);
    } else {
      if (this.currentSearch) {
        this.route.navigateByUrl(`product/${slug}?q=${this.currentSearch}`);
      } else {
        this.route.navigateByUrl(`product/${slug}`);
      }
    }
  }

  private storeProductInSessionStorage(product: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const recentViewsStr = sessionStorage.getItem('recentlyViewed');
        let recentViews: any[] = recentViewsStr ? JSON.parse(recentViewsStr) : [];

        recentViews = recentViews.filter((item: any) => item.urlSlug !== product.urlSlug);

        recentViews.unshift(product);

        if (recentViews.length > 10) {
          recentViews = recentViews.slice(0, 10);
        }
        sessionStorage.setItem('recentlyViewed', JSON.stringify(recentViews));
      } catch (error) {
        console.error('Error storing product in session storage:', error);
      }
    }
  }

  toggleQuantityVisibility(slug: string, isLogin: boolean, item: any) {
    this.hideTooltip = false;
    const state = this.initQuantityState(slug);

    if (item.istwice || !isLogin || item?.productStatus === 4 || item?.productStatus === 0) return;

    state.visible = true;
  }

  private initQuantityState(slug: string) {
    if (!this.showQuantityState[slug]) {
      this.showQuantityState[slug] = { visible: false, locked: false };
    }
    return this.showQuantityState[slug];
  }

  out(slug: string) {
    const state = this.showQuantityState[slug];
    if (!state) return;

    if (!state.locked) {
      state.visible = false;
    }
  }

  // async handleMinus(cart: any, event: Event) {
  //  this.handleMinusFunc(cart,event)
  // }
  // handlePlus(cart: any, event: Event, val = false) {
  //  this.handlePlusFunc(cart,event,val)
  // }
  // enableMobilePopup() {
  //   this.enableMobilePopupFunc()
  // }

  getInputWidth(val: any): string {
    if (val !== undefined && val !== null) {
      let num = val.toString();
      if (!num || num.length < 2) {
        if (this.gridView) {
          return '1ch';
        }
        return '2ch';
      }
      return num.length + 'ch';
    }
    if (this.gridView) {
      return '1ch';
    }
    return '2ch';
  }

  isItemInCompareList(item: any): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const compareList = JSON.parse(localStorage.getItem('compareList') || '[]');
      return compareList.some((i: any) => i.urlSlug === item.urlSlug);
    }
    return false;
  }

  // async onClickWishlist(item: any, event: Event, userName: any) {
  //   this.onClickWishlistFunc(item,event,userName)
  // }

  getTagName(item: any): string {
    if (item?.inventoryQty === false && item?.productStatus === 3) {
      if (item.isInQuote) return 'View Quotes'
      return "Request a Quote"
    } else if (item?.inventoryQty === false && item?.productStatus !== 3 && item?.productStatus !== 0) {
      return "Pre-Order Now"
    } else {
      return "Add to Cart"
    }
  }

  isRequestQuote(item: any) {
    return item?.inventoryQty === false && item?.productStatus === 3 && this.isLogin
  }

  isMobile(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return window.innerWidth <= 751;
    }
    return false;
  }
  // async handleMultiple(item: any, event: Event) {
  //   event.stopPropagation();
  //   if (!item || !item.cartQty || item.cartQty < 0) return;
  //   clearTimeout(this.debounceTimer);
  //   let inCart = this.cartList?.items?.find((cart: any) =>
  //     cart.product?.urlSlug
  //       ? cart.product.urlSlug == item.urlSlug
  //       : cart.urlSlug == item.urlSlug
  //   );
  //   if (inCart) {
  //     const cartId = inCart.cartId;
  //     this.debounceTimer = setTimeout(async () => {
  //       if (item.cartQty == 0) this.zeroQty(item);
  //       let cartData = await this.api.updateCart(cartId, item.cartQty);
  //       this.util.CartUpdated(cartData);
  //       this.cartList = cartData;
  //     }, 500);
  //   } else {
  //     this.debounceTimer = setTimeout(async () => {
  //       if (item.cartQty == 0) this.zeroQty(item);
  //       let res = await this.performAddToCart(item, item.cartQty);
  //       this.util.CartUpdated(res);
  //       this.cartList = res;
  //     }, 500);
  //   }
  // }

  handleRequestQuoteClick(item: any) {
    if (this.getTagName(item) === 'View Quotes') {
      this.route.navigateByUrl('account/quotes/cart');
    } else {
      this.toggleQuantityVisibility(item.urlSlug, this.isLogin, item);
    }
  }

  getWishlistTooltip(item: any): string {
    if (!this.isLogin) return 'Log in to save favorites';
    return item.isWishlisted || item.customerWishListId ? 'Remove from wishlist' : 'Add to wishlist';
  }

  getProductTooltip(item: any): string {
    if (!this.isLogin) return 'Log in to add to cart';
    else if (item.istwice) return 'Multiple in cart';
    else return 'Add To Cart';
  }

  showLoginPopup(wishlist: boolean = true) {
    this.resetTooltip();
    console.log(this.wishlistLogin, this.showLogin, 'show login popup')
    if (this.item) {
      this.storeProductInSessionStorage(this.item);
    }

    if (!wishlist) {
      this.showLogin = true
      this.wishlistLogin = false;
      return
    } else {
      if (isPlatformBrowser(this.platformId)) {
        let popup = sessionStorage.getItem('popup')
        if (popup) {
          this.showLogin = false;
          this.wishlistLogin = false;
          return
        }
        sessionStorage.setItem('popup', 'true')
      }
      this.wishlistLogin = true;
      this.showLogin = true;
    }
    this.startAutoHideTimer();
  }

  startAutoHideTimer() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
    }
    this.autoHideTimer = setTimeout(() => {
      this.showLogin = false;
      this.wishlistLogin = false;
      this.hideMobileTooltip()
    }, 3000);
  }

  resetTooltip() {
    this.hideTooltip = false;
    this.lockedWishlistTooltip = this.getWishlistTooltip(this.item);
    this.lockedProductTooltip = this.getProductTooltip(this.item);
  }

  getItemQuantity(item: any): number {
    return this.isRequestQuote(item) ? item.quoteQty || 0 : item.cartQty;
  }

  setItemQuantity(item: any, value: number) {
    if (this.isRequestQuote(item)) {
      item.quoteQty = value;
    } else {
      item.cartQty = value;
    }
  }

  async addToQuote(item: any) {
    if (this.isProcessing) return;
    try {
      // const quotes = this..getQuotesValue();
      if (item.quoteQty && item.quoteQty >= 1) {
        item.quoteQty += 1;

        // let quote = this.QuotesId.find(
        //   (quote: any) => quote.product.urlSlug == item.urlSlug
        // );

        if (item?.quoteIDs[0]) {
          let res = await this.api.updateQuoteQty(
            item.quoteIDs[0],
            item.quoteQty
          );
          if (res) {
            this.hideMobileTooltip()
            this.util.setQuotes(res.items);
            this.util.showQuotesToast('Item added to Quote List', 'success', undefined);
          }
        }
        return;
      }
      this.isProcessing = true;
      item.quoteQty = 1;

      let data = {
        qty: 1,
        productSlug: item.urlSlug,
      };

      let res = await this.api.addToQuote(data);
      if (res) {
        this.hideMobileTooltip()
        this.util.handleQuoteResponse(res, item);
        item.isInQuote = true
        let quote = res.items.find((quote: any) => quote.product.urlSlug == item.urlSlug);
        item.quoteIDs[0] = quote.quoteId
      }
    } catch (err: any) {
      if (this.util.isCustomerNotFoundError(err)) {
        this.util.showQuotesToast('Please login with a customer', 'error', 'Error');
        item.quoteQty = 0;
        return;
      }
      this.util.showQuotesToast('Error', 'error', 'Item Not Added to Quote List',);
    } finally {
      this.isProcessing = false;
    }
  }


  async updateMinusQuotes(item: any) {
    try {
      // const quotes = this.util.getQuotesValue();
      if (item.quoteQty > 0) {
        item.quoteQty -= 1;
        // let quote = this.QuotesId.find((quote: any) => quote.product.urlSlug == item.urlSlug)
        if (item.quoteIDs[0]) {
          if (item.quoteQty == 0) {
            let res = await this.api.removeQuote(item.quoteIDs[0])
            this.hideMobileTooltip()
            this.item.isInQuote = false
            this.util.showQuotesToast('Success', 'success', 'Item removed from quote');
            this.util.setQuotes(res.items)
            return
          }

          let res = await this.api.updateQuoteQty(item.quoteIDs[0], item.quoteQty);
          if (res) {
            this.hideMobileTooltip()
            this.util.setQuotes(res.items)
            this.util.showQuotesToast('Success', 'success', 'Item removed from quote');
            // this.quotesList = res.items;
            // this.total = res.total;
            // this.quotesData.subTotal = res.subTotal;
          }
        }
      }
    } catch (err: any) {
      console.error(err)
      this.util.showQuotesToast('Error', 'error', 'No Item Found in Quote List',);
    }
  }

  // handleMulti(item: any, event: Event) {
  //   // this.enableMobilePopup()
  //   this.handlePlus(item, event)
  // }

  checkForMobileAndQuote(item: any) {
    return this.isRequestQuote(item) && item.quoteQty > 0
  }

  openMobileCartPopup(event: Event) {
    event.stopPropagation();
    this.util.triggerMultipleVarients(this.item);
  }

  switchPopupMode(mode: 'list' | 'configure') {
    this.popupMode = mode;
  }

  getLockedWishlistTooltip(item: any): string {
    return this.lockedWishlistTooltip;
  }

  getLockedProductTooltip(item: any): string {
    return this.lockedProductTooltip;
  }

  hideMobileTooltip() {
    this.hideTooltip = false;
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
    this.tooltipTimeout = setTimeout(() => {
      this.hideTooltip = true;
      this.lockedWishlistTooltip = '';
      this.lockedProductTooltip = '';
    }, 2000);
  }
}
